import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SingleListSelectorHeading.scss';

class SingleListSelectorHeading extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animate: true,
    };
  }

  render() {
    const { children, extraClass, tagline, title } = this.props;
    const wrapperClass = classnames('single-list-selector__heading', {
      [extraClass]: extraClass,
    });
    return (
      <div className={wrapperClass}>
        <h2>{title}</h2>
        {children}
        {
          tagline && (
          <div className="meta">
            {tagline}
          </div>
          )}
      </div>
    );
  }
}

SingleListSelectorHeading.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  extraClass: PropTypes.string,
  tagline: PropTypes.string,
  title: PropTypes.string.isRequired,
};

SingleListSelectorHeading.defaultProps = {
  children: null,
  extraClass: '',
  tagline: '',
};

export default SingleListSelectorHeading;
